import { combineReducers } from 'redux';
import webtourOverlay from './webtourOverlay';

export default combineReducers({
  webtourOverlay,
});
